import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { range } from '@sorare/core/src/lib/arrays';

const Increment = styled.div`
  border-radius: 2px;
  height: var(--unit);
  width: 6px;
  background: var(--c-nd-150);

  &.filled {
    background: var(--league-color);
  }
`;

type Props = { progress: number; target: number; color: string };
export const StarPackProgress = ({ progress, target, color }: Props) => {
  return (
    <Tooltip
      title={
        <FormattedMessage
          id="StarPackProgress.tooltip"
          defaultMessage="Progress {progress} / {target}"
          values={{ progress, target }}
        />
      }
    >
      <Horizontal gap={0.5}>
        {...range(target).map(value => {
          return (
            <Increment
              key={value}
              className={classNames({ filled: value < progress })}
              style={{ '--league-color': color } as CSSProperties}
            />
          );
        })}
      </Horizontal>
    </Tooltip>
  );
};
